import { useParams } from 'react-router-dom'
import { useStaffGetAgentsInAgency } from '@urbanx/agx.agencies.client'

const useAgentsInAgency = () => {
  const { agencyId } = useParams()

  return useStaffGetAgentsInAgency(agencyId!, agencyId !== undefined)
}

export default useAgentsInAgency
